$(function() {
    if ($('.hero--animated-text')[0]) {
        $(document).ready(function() {
            var topText = $('.hero--animated-text .top-text');
            var logo = $('.hero--animated-text__logo');
            var title = $('.hero--animated-text .hero__titles');
            var copy = $('.hero--animated-text .hero-copy');
            var svgText = $('.hero--animated-text .text-path');
            var timeoutDuration = 1500;

            setTimeout(function() {
                if (topText.length) {
                    $(topText).addClass('hide-now');
                }
            }, timeoutDuration);

            if (!topText.length) {
                timeoutDuration -= 500;
            }

            setTimeout(function() {
                $(logo).addClass('animated');
            }, timeoutDuration + 500);

            setTimeout(function() {
                $(svgText).addClass('transparency');
            }, timeoutDuration + 2000);

            setTimeout(function() {
                $(title).addClass('animated');
            }, timeoutDuration + 3000);

            setTimeout(function() {
                $(copy).addClass('animated');
            }, timeoutDuration + 4500);
        });
    }
});
